export default __webpack_public_path__ + "static/media/ic_product_vorsorge-platin.17f6872d.svg";